import React, {Component} from "react";
import { classNames } from "../../common/util/util-helpers";

export default function FieldTextarea({item = {}, onChange}) {
    if (!item.props) {
        item.props = {};
    }
    return (
        <React.Fragment>
            <textarea
                rows={(item.props.rows ? item.props.rows : 4)}
                onChange={(event) => {
                    onChange(item.name, event.target.value);
                }}
                name={item.name}
                value={item.value}
                placeholder={item.props.placeholder}
                disabled={item.disabled}
                className={
                    classNames(
                        item?.props?.className ?? "form-control",
                        !!item.errorMessage ? item?.metadata?.errorClass ?? "form-control-error" : undefined
                    )
                }
            />
        </React.Fragment>
    )
}